{{#if error}}
<div class="row">
	<div class="col-xs-12">
		<div class="alert alert-danger">
			{{error}}
		</div>
	</div>
</div>
{{/if}}
